import { render, staticRenderFns } from "./TemplateManagementModal.vue?vue&type=template&id=41598b37&scoped=true"
import script from "./TemplateManagementModal.vue?vue&type=script&lang=js"
export * from "./TemplateManagementModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateManagementModal.vue?vue&type=style&index=0&id=41598b37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41598b37",
  null
  
)

export default component.exports